import { configure, makeAutoObservable } from "mobx";
import io from "socket.io-client";

configure({
  enforceActions: "observed",
});

class GCXStore {
  isLoading = false;
  user = {};
  campaign = [];
  raised = 0;
  goal = 0;
  percent = 0;
  progress = 0;
  socket = false;
  error = false;
  campaignID = 0;

  constructor() {
    makeAutoObservable(this);
  }

  socketDisconnect() {
    this.socket.disconnect();
  }

  socketConnect(streamType, username, slug) {
    this.setIsLoading(true);
    this.setUserInfo(username, streamType, slug);

    this.socket = io(process.env.REACT_APP_SERVICE_URI, {
      query: `type=${this.streamType}&username=${this.username}&slug=${this.slug}`,
      withCredentials: false,
    });

    this.socket.on("error", (error) => {
      console.log("error", error);
      this.setError(error);
    });

    this.socket.on("connect_error", (error) => {
      console.log("connect_error", error);
      this.setError(error);
    });

    this.socket.on("user", (data) => {
      // "User" is a misnomer. The data received is a campaign.
      const campaign = data;
      this.setCampaign(campaign);
      this.setError(false);

      this.socket.on("donations", (data) => {
        this.setError(false);
        const donations = data;
        this.setDonations(donations);
      });

      this.socket.on("totals", (data) => {
        const campaign = data;
        this.setCampaign(campaign);

        const numRaised = Number(campaign.amount_raised.value);
        const numGoal = Number(campaign.goal.value);
        const teamNumRaised = Number(campaign.total_amount_raised.value);
        this.setTotals(numRaised, numGoal, teamNumRaised);

        this.setIsLoading(false);
      });

      this.socket.emit("getData", this.campaign);
      this.setIsLoading(false);
    });
  }

  setCampaign = (campaign) => {
    this.campaign = campaign;
  };

  setCampaignID = (campaignID) => {
    this.campaignID = campaignID;
  };

  setCause = (cause) => {
    this.cause = cause;
  };

  setDonations = (donations) => {
    this.donations = donations;
    const calcSpeed = (speed) => {
      // Time = Distance/Speed
      let spanSelector = document.querySelectorAll(".marquee-wrap .scroller"),
        i;
      for (i = 0; i < spanSelector.length; i++) {
        const spanLength = spanSelector[i].offsetWidth,
          timeTaken = spanLength / speed;
        spanSelector[i].style.animationDuration = timeTaken + "s";
      }
    };
    calcSpeed(40);
  };

  setError = (error) => {
    this.error = error;
  };

  setIsLoading = (boolean) => {
    this.isLoading = boolean;
  };

  setTotals = (raised, goal, teamRaised) => {
    this.raised = this.streamType === "@" ? raised : teamRaised;
    this.goal = goal;

    const formatNumber = (num) => {
      let value = num;
      const res = String(num).split(".");
      if (res.length === 1 || res[1].length <= 3) {
        value = value
          .toFixed(2)
          .replace(/\.00$/, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      return value;
    };

    this.raisedVal = formatNumber(raised);
    this.goalVal = formatNumber(goal);

    this.percent = Math.floor(
      100 *
        (parseFloat(this.streamType === "@" ? raised : teamRaised) /
          parseFloat(goal))
    );

    this.exactPercent = Number(100 * (Number(raised) / Number(goal)));
    this.progress = this.percent > 100 ? 100 : this.percent;
    this.remaining = (this.goal - this.raised).toFixed(2);
    this.remainingVal = formatNumber(Number(this.remaining));

    {
      this.goal >= 5000
        ? (this.gtgGoal = 5000)
        : this.goal >= 2000
        ? (this.gtgGoal = 2000)
        : this.goal >= 1000
        ? (this.gtgGoal = 1000)
        : 0;
    }

    this.gtgPercent = Math.round(
      100 * (parseFloat(this.raised) / parseFloat(this.gtgGoal))
    );

    this.gtgProgress = this.gtgPercent > 100 ? 100 : this.gtgPercent;
  };

  setUserInfo = (user, streamType, slug) => {
    this.slug = slug;
    this.streamType = streamType;

    if (streamType === "@" || streamType === "+") {
      this.username = user;
    } else {
      this.broadcaster_id = user;
    }
  };
}

export default new GCXStore();
